<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <div></div>
          <el-input
            class="search-input"
            placeholder="请输入搜索内容"
            v-model="search_name"
            prefix-icon="el-icon-search" @keyup.enter.native="searchName">
          </el-input>
        </div>
        <el-table
          class="table-container"
          :data="tableData"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="customer_name"
            label="客户名称">
          </el-table-column>
          <el-table-column
            prop="start_date"
            label="起始日期">
          </el-table-column>
          <el-table-column
            prop="end_date"
            label="截止日期">
          </el-table-column>

          <el-table-column
            prop="payment"
            width="100"
            label="付费">
            <template slot-scope="scope">{{ scope.row.payment | pay_status_filter}}</template>
          </el-table-column>
          <el-table-column
            prop="create_date"
            width="100"
            label="发票">
            <template slot-scope="scope">{{ scope.row.receipt_status | receipt_status_filter}}</template>
          </el-table-column>
          <el-table-column
            prop="total"
            width="100"
            label="本期费用">
          </el-table-column>
          <el-table-column
            prop="receipt_no"
            label="发票号">
          </el-table-column>
          <el-table-column
            prop="memo"
            label="备注">
          </el-table-column>
          <el-table-column width="100" label="操作" class="btn-container">
            <template slot-scope="scope" class="btn-container">
              <el-button
                class="edit-btn"
                @click="handleEdit(scope.row)"
                >
                <i class="el-icon-edit-outline"></i>
                修改
                </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <finance-tk v-if="update_show" :update="update_detail" @delete="cancle" @sure="sureDetail"></finance-tk>
  </div>
</template>

<script type="text/javascript">
import FinanceTk from "components/FinanceTk.vue"
export default {
  data () {
    return {
      tableData: [],
      total: 0,
      page: 1,
      limit: 10,
      empty: '没有合同客户未付费订单列表',
      loading: false,
      search_name: '',
      search_show: false,
      update_detail: {},
      update_show: false
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8;'
      } else {
        return ''
      }
    },
    initData () { // 初始化数据
      let that = this
      // 获取客户信息
      this.$api.getVipFinancial({
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.detail.length > 0) {
          that.tableData = res.data.detail
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.detail
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    searchName () { // 输入名字删除
      let that = this
      if (!this.search_show) {
        this.search_show = true
        this.page = 1
      }
      if (that.search_name) {
        this.$api.searchVipFinancial({
          search: that.search_name,
          page_num: (that.page - 1) * this.limit
        }).then(res => {
          if (res.data.detail.length > 0) {
            that.tableData = res.data.detail
            that.total = Number(res.data.total)
          } else {
            that.$message({
              type: 'error',
              message: '没有合同客户未付费订单列表',
              customClass: 'msg-position',
              showClose: true
            })
            that.tableData = []
            that.total = 0
          }
        }).catch(err => {
          that.$message({
            message: err,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          type: 'error',
          message: '搜索不能为空！！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      if (this.search_show) {
        this.searchName()
      } else {
        this.initData()
      }
    },
    handleEdit(row) {
      this.update_detail = {...row}
      this.update_detail.payment = Number(row.payment)
      this.update_detail.receipt_status = Number(row.receipt_status)
      this.update_show = true
    },
    cancle() {
      this.update_show = false
      this.$message({
        type: 'error',
        message: '取消修改操作',
        customClass: 'msg-position',
        showClose: true
      })
    },
    sureDetail(detail) {
      // !+detail.receipt_no 是因为 !"0"不等于true
      let that = this
      if (detail.receipt_status != 0 && !detail.receipt_no) {
        that.$message({
          type: 'error',
          message: '选择开票后发票不能空',
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      that.$api.saveVipReceipt({
        ...detail
      }).then(res => {
        if (res.data.msg == true) {
          if (that.search_show) {
            that.searchName()
          } else {
            that.initData()
          }
          that.$message({
            type: 'success',
            message: '修改成功！',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
        that.update_show = false
      })
    }
  },
  filters: {
    // 付费状态
    pay_status_filter(state) {
      if (state == 0) {
        return '未付'
      }
      if (state == 1) {
        return '已付'
      }
    },
    receipt_status_filter(state) {
      if (state == 0) {
        return '未开'
      } else {
        return '已开'
      }
    },
  },
  components: {
    FinanceTk
  }
}
</script>

<style lang="stylus" >
@import '~common/stylus/box.styl'
</style>
